<div class="header-and-search">
  <h4>{{'new_event.step3.location_placeholder' | translate}}</h4>
  <div class="location-selector">
    <location-search-field [data]="selectedLocationName" [includePOI]="true" (locationChanged)="onCustomLocationChanged($event)"></location-search-field>
  </div>
</div>
<div class="map-container">
  <azure-map #mapelement></azure-map>
</div>
